import { combineReducers } from 'redux';
import ocrReducer from './ocr/ocrSlice';
import bukuTarifReducer from './buku-tarif/bukuTarifSlice';

export const rootReducer = combineReducers({
  ocr: ocrReducer,
  bukuTarif: bukuTarifReducer,
});
